import * as React from "react";
import type { SVGProps } from "react";
const SvgHighindexIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="highindex_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 170.667a426.667 426.667 0 0 0-369.493 640A42.837 42.837 0 0 0 216.747 768a337.92 337.92 0 0 1-46.08-170.667A341.333 341.333 0 1 1 807.68 768a42.667 42.667 0 1 0 73.813 42.667 426.667 426.667 0 0 0-369.493-640zm121.173 245.76-66.133 65.706a124.16 124.16 0 0 0-55.04-12.8 128 128 0 1 0 128 128 123.733 123.733 0 0 0-12.8-54.613l66.133-65.707a42.752 42.752 0 0 0-30.08-72.96 42.667 42.667 0 0 0-30.08 12.374zM512 640a42.667 42.667 0 0 1 0-85.333 42.667 42.667 0 0 1 29.867 11.946 42.667 42.667 0 0 1 12.8 30.72A42.667 42.667 0 0 1 512 640z"
    />
  </svg>
);
export default SvgHighindexIcon;
